"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLang = void 0;
const getLang = () => {
    const e = document.querySelector('html');
    return e.lang;
};
exports.getLang = getLang;
